module.exports = __webpack_public_path__ + "img/NoPicture.bc59831b.png";